import Vue from 'vue';
import CookieNotification from './CookieNotification.vue';

export default function initCookieNotification() {
    if (document.getElementById('vue-cookies-app')) {
        new Vue({
            el: '#vue-cookies-app',
            components: {
                'cookie-notification': CookieNotification,
            },
        });
    }
}
